import { Unit } from '@cco/model';
import { EntitySelectorsFactory } from '@ngrx/data';
import { Dictionary } from '@ngrx/entity';
import { createSelector } from '@ngrx/store';

export const defaultMaxCacheAge = 600;

const entitySelectorFactory = new EntitySelectorsFactory();
const unitSelectors = entitySelectorFactory.create<Unit>('Unit');
export const selectUnitEntityMap = unitSelectors.selectEntityMap;
export const selectUnitsByIds = (props: { ids: number[] }) => createSelector(
  selectUnitEntityMap,
  (unitEntities: Dictionary<Unit>
) => {
    if (!unitEntities || !props.ids) {
      return [];
    }

    return props.ids.map(id => unitEntities[id]);
  },
);
export const selectUnitsByDimensionId = createSelector(
  unitSelectors.selectEntities,
  (units: Unit[], props: { dimensionId: number }) => {
    if (!units) {
      return [];
    }
    return units.filter(unit => unit.dimensionId === props.dimensionId);
  },
);
export const selectUnitsByDimensionIds = createSelector(
  unitSelectors.selectEntities,
  (units: Unit[], props: { dimensionIds: number[] }) => {
    if (!units) {
      return [];
    }
    return units.filter(unit => props.dimensionIds.includes(unit.dimensionId));
  },
);
export const selectUnitConversionRatio = createSelector(
  unitSelectors.selectEntityMap,
  (unitEntities: Dictionary<Unit>, props: { fromId: number; toId: number }) => {
    if (
      !unitEntities ||
      !unitEntities[props.fromId] ||
      !unitEntities[props.fromId].unitConverters
    ) {
      return null;
    }

    const unitConverter = unitEntities[props.fromId].unitConverters.find(
      converter => converter.toId === props.toId,
    );
    if (!unitConverter) {
      return null;
    }

    return unitConverter.conversionRatio;
  },
);
